import {
  CategoriesFindAllPayload,
  CategoryService,
} from "@/services/categories.service";
import { CategoryPayload } from "@/domain/category.interface";
import { useMutation, useQuery } from "@tanstack/react-query";

export const useCategoryByType = ({
  type,
  status,
  action,
}: {
  type: string;
  status: string;
  action?: string;
}) => {
  const {
    data: category,
    isLoading: isLoadingCategory,
    refetch: refetchCategory,
  } = useQuery({
    queryKey: ["category", { type }, { action }],
    queryFn: async () => CategoryService.findByType({ type, status }),
  });

  return {
    category,
    isLoadingCategory,
    refetchCategory,
  };
};

export const useCategories = (filters: CategoriesFindAllPayload) => {
  const {
    data: categories,
    isLoading: isLoadingCategories,
    isFetching: isFetchingCategories,
    refetch: refetchCategories,
  } = useQuery({
    queryKey: ["parca-categories-list"],
    queryFn: () => CategoryService.findAll(filters),
  });

  return {
    categories,
    isLoadingCategories,
    isFetchingCategories,
    refetchCategories,
  };
};

export const useCreateCategory = () => {
  return useMutation({
    mutationFn: (payload: CategoryPayload) =>
      CategoryService.createOne(payload),
  });
};

export const useUpdateCategory = () => {
  return useMutation({
    mutationFn: ({ id, payload }: { id: string; payload: CategoryPayload }) =>
      CategoryService.updateOne({ id, payload }),
  });
};

export const useArchiveCategory = () => {
  return useMutation({
    mutationFn: (id: string) => CategoryService.archiveOne(id),
  });
};
